module.exports = __webpack_public_path__ + "media/images/850/circadian_rhytm_mimosa_pudica-1803b36799c34c3638cea51c6f290a95.webp";